<template>
  <v-row class="label-bold">
    <div class="row-block">
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="3">
        <div class="test-name-block">
          <div class="ts-label">Test Name:</div>
          <div class="ts-field">
            <v-text-field v-model="testName" dense hide-details></v-text-field>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div class="row-block">
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="3">
        <div class="test-name-block">
          <div class="ts-label">Target Exam:</div>
          <div class="ts-field">
            <v-select
              v-model="selectedTarget"
              :items="targets"
              @change="reqGetTestPattern()"
              class
              dense
              hide-details
              filled
            ></v-select>
          </div>
        </div>
      </v-col>
    </div>
    <div class="row-block">
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="3">
        <div class="test-name-block">
          <div class="ts-label">Pattern:</div>
          <div class="ts-field">
            <v-select
              v-model="selectedPatterns"
              :items="patterns"
              @change="changePatterns()"
              class
              dense
              hide-details
              filled
            ></v-select>
          </div>
        </div>
      </v-col>
    </div>
    <div class="row-block">
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="6">
        <div class="Select-label">Select Category:</div>
        <div class="sub-block">
          <v-select
            v-model="selectedClasses"
            :items="classes"
            class
            dense
            hide-details
            filled
            @change="clearSubjectList()"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div class="row-block" v-if="selectedClasses">
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="6">
        <div class="Select-label">Select Subject(s):</div>
        <div class="sub-block">
          <v-autocomplete
            ref="autoSearch"
            v-model="selectedSubjects"
            :items="subjects"
            @change="onSelectSubject"
            dense
            outlined
            hide-details
            chips
            color="blue-grey lighten-2"
            item-text="text"
            item-value="value"
            multiple
          >
            <template v-slot:selection="data">
              <v-chip
                class="name-chip"
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="remove(data.item)"
                >{{ data.item.text }}</v-chip
              >
            </template>
          </v-autocomplete>

          <div class="add-field drop-hg-35">
            <!-- <v-select :items="subjects" class="" hide-details dense filled></v-select> -->
          </div>
          <div class="add-field">
            <!-- <v-select :items="itemsdrop" class="" hide-details dense filled></v-select> -->
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div
      class="row-block may-18-pattern"
      v-if="selectedSubjects && selectedSubjects.length"
    >
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="7" class="pd-diff-7">
        <div class="Select-label">Difficulty Level:</div>
        <v-row class="difficulty-subject">
          <v-col
            col="12"
            lg="3"

            class="difficulty-col"
            v-for="subject in selectedSubjectWithDifficultyLevel"
            :key="subject.id"
          >
          <div class="slider-row">
            <div class="sub-block hide-none">
            </div>
            <div class="subject-title-slide Select-label" style="display: flex; align-items: center; justify-content: space-between;">
              <span style="font-weight: 600;">{{ subject.title }}:</span>
              <v-tooltip top content-class="cust-new-tooltip-top">
                <template v-slot:activator="{ on }">
                  <div class="max-char" v-on="on" style="width: max-content;">
                    <v-btn 
                    v-on="on" 
                    style="min-width: auto;width: 28px;height: 28px; padding: 0.75rem; border-radius: 50%;" 
                    @click="toggleEdit(subject)"
                    >
                    <v-icon size="large" color="black">
                      {{ subject.isDisabled ? 'edit' : 'save' }}
                    </v-icon>
                  </v-btn>
                  </div>
                </template>
                <span >{{ subject.isDisabled ? 'Edit' : 'Save' }}</span>
              </v-tooltip>   
            </div>
            <div class="slider-outer">
              <div class="mx-auto mt-2" max-width="600">
                <div class="wrapper" v-for="(diff, diffIndex) in difficulty" :key="diff.id">
                  <div class="diff-row" >
                    <span class="subheading">{{ diff.text }}</span>
                    <div>
                      <span v-if="diff.text.toLowerCase() === 'tough' || subject.isDisabled">
                        {{ !subject[diff.text.toLowerCase()] && subject[diff.text.toLowerCase()] !== 0 ? diff.percentage : subject[diff.text.toLowerCase()] }}
                      </span>
                      <input
                        v-if="!subject.isDisabled && diff.text.toLowerCase() !== 'tough'"
                        type="number"
                        :disabled="diff.text.toLowerCase() === 'tough'"
                        v-model="subject[diff.text.toLowerCase()]"
                        @input="updateToughValue(subject)"
                        min="0"
                        max="100"
                        class="percentage-input"
                      />
                      <span class="subheading font-weight-light mr-1">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </v-col>
        </v-row>
        </v-col>
        <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div class="row-block may-18-full-btn">
      <v-col cols="12" sm="3" class="blank-div"></v-col>
      <v-col cols="12" sm="6">
        <v-btn
          @click="
           test
            
          "
          class="left-btn cust-btn min-125 myt-btn-space "
          color="primary"
          >Customize Syllabus</v-btn
        >
        <v-btn
          @click="
            processTestData({
              testName,
              duration,
              selectedSubjects: selectedSubjectWithDifficultyLevel,
              selectedTarget,
              selectedClasses,
              selectedPatterns,
            })
          "
          class="left-btn cust-btn min-125"
          color="primary"
          >Create Full Test</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6"> </v-col>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onCloseAlertBox"
      :component="cComponent"
      :status="open"
      :data="customErrorMsg"
    />
  </v-row>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "MYTPatternI",
  props: ["onNextClick", "data"],
  mounted() {
    this.getClasses();
    this.reqGetTestTargets();
    if (this.data) {
      (async ()=>{
        this.selectedSubjects = null;
        this.duration = this.data.duration;
        this.testName = this.data.testName;
        this.selectedTarget = this.data.selectedTarget;
        this.selectedClasses = this.data.selectedClasses;
        this.selectedPatterns = this.data.selectedPatterns;
        await this.getSubjects();
        const test = _.cloneDeep(this.data.selectedSubjects);
        let difficultyCheck = [];
        this.selectedSubjects = this.selectedSubjects.map((s) => {
          difficultyCheck.push(s);
          delete s.difficulty;
          delete s.easy;
          delete s.moderate;
          delete s.tough;
          delete s.sortBy;
          return s;
        });
        this.selectedSubjectWithDifficultyLevel = this.data.selectedSubjects;
        this.selectedSubjects = test.map((res$)=>{
          return {text : res$.title,value: { ...res$ },checked : true}
        });
      })();
    }
  },
  data() {
    return {
      subjects: [],
      loading: false,
      duration: 0,
      testName: null,
      targets: [],
      selectedSubjects: [],
      modalwidth: null,
      selectedTarget: null,
      classes: [],
      selectedClasses: null,
      showDifficulty: false,
      difficulty: constants.DIFFICULTY_LEVELS,
      patterns: [],
      selectedPatterns: null,
      cComponent: "",
      open: "",
      customErrorMsg: null,
      selectedSubjectWithDifficultyLevel: [], 
    };
  },
  methods: {
    test(){
      this.processTestData({
        testName: this.testName,
              duration: this.duration,
              selectedSubjects: this.selectedSubjectWithDifficultyLevel,
              selectedTarget: this.selectedTarget,
              selectedClasses: this.selectedClasses,
              selectedPatterns: this.selectedPatterns
      },
    true, true)
      
    },
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getTestPatterns: "utilStore/getTestPatterns",
      createCustomTestAPI: "testStore/createCustomTest",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
    }),
    clearSubjectList() {
      this.selectedSubjects = null;
    },

    remove(item) {
      const index = this.selectedSubjects.indexOf(item.value);
      if (index >= 0) this.selectedSubjects.splice(index, 1);
    },
    reqGetTestTargets() {
      this.getTestTarget({})
        .then((response) => {
          this.loading = false;
          this.targets = response.filter((x) => x?.name === 'JEE Main' || x?.name === 'NEET').map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = false;
            return c;
        });
          this.targets = this.targets.filter((t) => t.value != 4);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getClasses() {
      let reqData = {
        level: 1,
      };

      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.loading = false;
          this.classes = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x;
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    reqGetTestPattern() {
      this.selectedSubjects = null;
      this.selectedClasses = null;
      this.selectedPatterns = null;
      this.getTestPatterns({ test_target_id: this.selectedTarget })
        .then((response) => {
          this.loading = false;
          this.patterns = response.filter((item)=> item?.pattern_name.includes('2025')).map((x) => {
            let c = {};
            c.text = x.pattern_name;
            c.value = x;
            c.value.test_params =
            //-------------MYSQL 9 Change : -------------
              c.value.test_params && typeof c.value.test_params === "string"
                ? JSON.parse(c.value.test_params)
                : c.value.test_params;
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    changePatterns() {
      this.subjects = [];
      this.selectedSubjects = null;
      this.selectedClasses = null;
      this.selectedPatterns.subject_list.map((x) => {
        let c = {};
        if (x.id === constants.BIOLOGY_SUBJECT_ID) {
          constants.BIOLOGY_SUBSUBJECTS.map((s) => {
            let sub = {};

            sub.text = s.title;
            sub.value = { ...s };
            sub.checked = false;
            this.subjects.push(sub);
          });
        } else {
          c.text = x.title;
          c.value = { ...x };
          c.checked = false;
          this.subjects.push(c);
        }
      });
    },
    validate(data) {
      let subject_ids = [];
      if (!data || !data.testName || data.testName.trim().length === 0) {
        this.$toasted.error(`Please enter test name`, { icon: "info" });
        return false;
      } else if (data && data.testName && data.testName.trim().length > 50) {
        this.$toasted.error(
          `Test Name should not contain more than 50 characters`,
          { icon: "info" }
        );
        return false;
      } else if (!data.selectedTarget || data.selectedTarget.length === 0) {
        this.$toasted.error(`Please select exam target`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedPatterns) {
        this.$toasted.error(`Please select exam pattern`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedClasses) {
        this.$toasted.error(`Please select data type`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedSubjects || data.selectedSubjects.length === 0) {
        this.$toasted.error(`Please select subject`, { icon: "info" });
        return false;
      } else if (data.selectedSubjects && data.selectedSubjects.length) {
        let subjectDiff100 = [],subjectDifficulty=[];
        let valid = true;

        data.selectedSubjects.map((s) => {
          if (!(s.easy || s.moderate || s.c)) {
            subjectDifficulty.push(s.title);
            valid = false;
          }
          let total = s.easy + s.moderate + s.tough;
          if (total != 100 && !subjectDifficulty.includes(s.title)) {
            subjectDiff100.push(s.title);
            valid = false;
          }
        });
        if (subjectDifficulty && subjectDifficulty.length) {
          this.$toasted.error(
            `Please select difficulty level for ${subjectDifficulty.join(", ")}`,
            {
              icon: "info",
            }
          );
          
        }
        if (subjectDiff100 && subjectDiff100.length) {
          
          this.$toasted.error(`Please check sum for ${subjectDiff100.join(", ")} should be equal to 100%`, {
            icon: "info",
          });
        }
        if (!valid) {
          return false;
        }
      }

      return true;
    },
   processTestData(data, nextPage, isCustomizeSyllabus = false) {
  this.duration = 0;
  let chapterId = 0,
    questions = [],
    questionNo = 0,
    subIndex = 0,
    optionalQuestionsList = [];

  if (this.validate(data)) {
    
    let hasZ = data.selectedSubjects.some((s) => s.code === "z");
    let hasB = data.selectedSubjects.some((s) => s.code === "b");
    let onlyZorB = data.selectedSubjects.every((s) => s.code === "z" || s.code === "b");

    if( data.selectedSubjects &&  data.selectedSubjects.length > 0 &&  (data.selectedSubjects[0].title === "Physics"|| data.selectedSubjects[0].title === "Chemistry")){
    this.duration = this.selectedPatterns.test_params[0].duration;
    } else if (this.selectedPatterns?.pattern_name.includes('JEE MAIN') && data.selectedSubjects[0].title !== "Physics"){
    this.duration = this.selectedPatterns.test_params[0].duration;
    }

    if (onlyZorB) {
      this.duration = hasZ && hasB ? 60 : 30; 
    }

    data.selectedSubjects.forEach((s) => {
      let currentSubjectId =
        data.selectedSubjects[0] ? this.getSubjectId(data.selectedSubjects[0]) : 0;
      let sub_subject;

      this.selectedPatterns.test_params.forEach((p, index) => {
        if (
          p.question_type_id !== this.QUE_TYPES.COMPREHENSION &&
          p.question_type_id !== this.QUE_TYPES.TC &&
          p.optional_question &&
          parseInt(p.optional_question.no_of_mandatory_questions) < 
          parseInt(p.optional_question.number_of_question) &&
          p.subject_ids.includes(currentSubjectId)
        ) {
          let newMandatoryQueObj = {
            noOfMandatoryQuestions: parseInt(p.optional_question.no_of_mandatory_questions),
            allowAll: parseInt(p.optional_question.allow_all),
            numberOfQuestions: parseInt(p.optional_question.number_of_question),
            mandatoryQuestionId: null,
            questionType: p.question_type_id,
            subType: p.question_subType_id,
            subject: this.getSubjectId(s),
            sub_subject: s.code || "null",
          };
          optionalQuestionsList.push(newMandatoryQueObj);
        }

        if (!onlyZorB) { 
          if (currentSubjectId !== s.id && !this.checkBiology(s)) {
            currentSubjectId = this.getSubjectId(s);
            this.duration += p.duration;
            ++subIndex;
          } else if (this.checkBiology(s) && sub_subject !== s.code) {
            sub_subject = s.code;
            this.duration += 30;
            ++subIndex;
          }
        }

        if (
          p.subject_ids.includes(this.getSubjectId(s)) ||
          (this.selectedPatterns.id === 15 &&
            ((p.subject_ids[0].includes(this.getSubjectId(s))) ||
             (p.subject_ids[1].includes(this.getSubjectId(s))) ||
             (p.subject_ids[2].includes(this.getSubjectId(s))) ||
             (data.selectedSubjects.length === 1 && 
              p.subject_ids[2].includes(this.getSubjectId(s)))))
        ) {
          questions.push({
            index: questionNo,
            subIndex: subIndex,
            subject: s,
            selectedSubType: p.question_subType_id,
            question_text: this.DUMMYTEXT,
            solution: this.DUMMYTEXT,
            correct_answer: null,
            options: [],
            options_abc: [],
            options_pqr: [],
            hints: [{ text: this.DUMMYTEXT }],
            questions: [],
            startValue: null,
            endValue: null,
            questionType: p.question_type_id,
            subtype: p.question_subType_id,
            correctMarkingSchema: p.positive_marks,
            inCorrectMarkingSchema: p.negative_marks || 0,
            partialMarking: p.partial_marking,
            required_questions: parseInt(p.number_of_question),
            l1_questions_required: s.easy,
            l2_questions_required: s.moderate,
            l3_questions_required: s.tough,
          });
          questionNo++;
        }
      });
    });

    data.duration = this.duration;
    let questionList = questions;

    if (nextPage) {
      this.onNextClick({ ...data, questionList, optionalQuestionsList }, isCustomizeSyllabus);
    } else {
      this.createCustomTest(questionList, optionalQuestionsList, false);
    }
  }
},
    createCustomTest(questions, optionalQuestionsList, confirmation) {
      this.$root.showLoader = true;
      let { list, forUpdate } = this.createTestData(
        { questions, optionalQuestionsList },
        confirmation,
        true
      );

      let reqData = {
        list: list,
        target_exam: this.selectedTarget,
        test_type: this.testType ? this.testType : this.TEST_TYPE.MYT,
        test_sub_type: this.TEST_SUB_TYPES.MYT,
        test_pattern: this.selectedPatterns.id,
        duration: this.duration,
        test_name: this.testName,
        optionalQuestionsList: optionalQuestionsList,
        instructions: this.selectedPatterns.pattern_instruction,
        pattern: this.selectedPatterns,
      };
      if (forUpdate) {
        reqData.only_question = true;
      }
      //   if (stepOneData.testId) {
      //     reqData.id = stepOneData.testId;
      //   }
      if (confirmation) {
        reqData.allowed_dummy_question = true;
      }

      this.createCustomTestAPI(reqData)
        .then((response) => {
          this.loading = false;
          let subjectCustomMsg = [];
          if (response.code === 204) {
            this.$root.showLoader = true;
            this.customErrorMsg = subjectCustomMsg;
            this.cComponent =
              "components/coordinator/Tests/CustomizedTests/MYTAlertBox";
            this.modalwidth = "525px";
            this.open = true;
          } else {
            this.$root.showLoader = false;

            this.$toasted.success(`Success\n${response.msg}`, {
              icon: "check_circle",
            });
            if (forUpdate) {
              this.onClose({
                status: false,
                reloadPreview: true,
              });
            } else {
              this.$router.push({ name: "make-your-test" });
            }
          }
          this.disableCreateTest = false;

          this.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$root.showLoader = false;
          this.disableCreateTest = false;
        });
    },
    onCloseAlertBox(data) {
      this.open = data.status;
    },
    increment(sub, key) {
      let subjects = [...this.selectedSubjects];
      let index = subjects.findIndex((s) => s.id === sub.id);
      let subject = subjects[index];
      subject[key.toLowerCase()] =
        subject[key.toLowerCase()] < 100 ? subject[key.toLowerCase()] + 1 : 100;
      subjects[index] = subject;
      this.selectedSubjects = [...subjects];
    },
    decrement(sub, key) {
      let subjects = [...this.selectedSubjects];
      let index = subjects.findIndex((s) => s.id === sub.id);
      let subject = subjects[index];
      subject[key.toLowerCase()] =
        subject[key.toLowerCase()] > 0 ? subject[key.toLowerCase()] - 1 : 0;
      subjects[index] = subject;
      this.selectedSubjects = [...subjects];
    },
    sliderChange(sub) {
      let subjects = [...this.selectedSubjects];
      let index = subjects.findIndex((s) => s.id === sub.id);
      let subject = subjects[index];
      subject.easy = constants.DIFFICULTY_PERCENTAGE[subject.difficulty].easy;
      subject.moderate =
        constants.DIFFICULTY_PERCENTAGE[subject.difficulty].moderate;
      subject.tough = constants.DIFFICULTY_PERCENTAGE[subject.difficulty].tough;
      subjects[index] = subject;
      this.selectedSubjects = [...subjects];
    },
    onSelectSubject() {
      if (this.selectedSubjects.length > 0) {
        this.selectedSubjectWithDifficultyLevel = this.selectedSubjectWithDifficultyLevel.filter(
          (item) => {
            return !!this.selectedSubjects.find((s) => {
              return s.id == item.id;
            });
          }
        );
        this.selectedSubjects.map((item) => {
          const e = this.selectedSubjectWithDifficultyLevel.find((s) => {
            
            
            return s.id == item.id;
          });
          if (!e) {
            const levels = constants.DIFFICULTY_LEVELS;
            const defaultScores = levels.reduce((acc, level) => {
                acc[level.title.toLowerCase()] = level.percentage;
                return acc;
            }, {});
            this.selectedSubjectWithDifficultyLevel.push({
              ...item,
              isDisabled: true,
              ...defaultScores // Assign default difficulty levels here
            });
          }
        });
      }
    },
    toggleEdit(subject) {
      if (subject.isDisabled) {
      
      // If currently disabled, enable editing
      subject.isDisabled = false;
      } else {
      // If currently editing, save and disable editing
      this.saveDifficulty(subject);
      if((Number(subject?.easy) + Number(subject?.moderate) + Number(subject.tough))>100){
      
      this.$toasted.error(`Please check sum for ${subject.title} should be equal to 100%`, {
        icon: "info",
      });

      }
      }
    },
    updateToughValue(subject) {
      const easy = subject.easy || 0;
      const moderate = subject.moderate || 0;
      // Ensure easy + moderate is less than or equal to 100
      const newToughValue = ((100 - (parseInt(easy) + parseInt(moderate))) >= 0 ?  100 - (parseInt(easy) + parseInt(moderate)) : 0);
      subject.tough = newToughValue;
    },
    saveDifficulty(subject){  
      subject.easy = Number(subject.easy);
      subject.moderate = Number(subject.moderate);
      subject.tough = Number(subject.tough);

      subject.isDisabled = true; // Disable editing after saving
    },
  },
};
</script>

<style lang="scss" scoped>
.percentage-input{
  margin-left: 0.15rem;
  padding: 0 0 0 0.25rem;
  width: 48px;
  text-align: right;
   border: 0.75px solid rgba(110, 107, 123, 1);
}
.slider-row{
  margin-bottom: -10px;
  padding: 15px;
  border: 1px solid rgba(110, 107, 123, 0.12);
  box-shadow: 0px 5px 20px rgba(34, 41, 47, 0.1);
  border-radius:6px;
  .sub-block{
    margin-left: 0px;
  }
.slider-outer{
  width: 100%;
  .v-input__slot{
    margin-bottom: -50px;
  }
  .card-text-padding{
    padding: 2px 9px;
  }
}

}
.Select-label-normal.subject-title-slide{
    margin-bottom: 7px;
}
.diff-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px 0px 0px;
}
.pd-diff-7{
  padding: 6px;
}
@media all and (max-width: 991px) {
    .percent_pos3{
      padding-bottom: 20px;
    }
  .mb-d-none{
    display: none;
  }
  .custom-test-button{
      flex: 0 0 100%;
      max-width: 100%;
  }
  .mobile-full-outer{
    flex: 0 0 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .diff-min-300{
    min-width: 300px;
  }
}
.outline-prepend-icon{
  border:1px solid #000;
}  
</style>
<style lang="scss">
.hide-error-msg{
  .v-messages{
    display: none;
  }
}
.hide-none {
  display: none;
}
</style>